<h1 mat-dialog-title>{{ data.title }}</h1>
<mat-dialog-content>
  <div style="color:green" [innerHTML]="data.text"></div>
  <div style="color:green" [innerHTML]="data.info"></div>
  <br>
    <div>
      <mat-label>Name </mat-label><input type="text" value="{{ data.contactName }}" (change)="data.contactName = $event.target.value" cdkFocusInitial style="width: 200px"><br><br>
      <mat-label>Number </mat-label><input type="text" value="{{ data.contactNumber }}" (change)="data.contactNumber = $event.target.value" style="width: 200px"><br><br>
      <mat-label>Email </mat-label><input type="email" value="{{ data.contactEmail }}" (change)="data.contactEmail = $event.target.value" style="width: 300px">
    </div>
  </mat-dialog-content>
  <mat-dialog-actions align="end">
    @if (data.showCancel) {
      <button class="btn btn-light" mat-button mat-dialog-close>Cancel</button>
    }
    <button class="btn btn-primary" mat-button [mat-dialog-close]="data">Save</button>
  </mat-dialog-actions>
